<template>
    <div v-if="props.chat.type === 'bot'">
        <div class="d-flex chat-content message">
            <img src="../assets/images/book-avatar.svg" alt="">

            <div v-if="props.chat.isLoading" class="d-flex justify-content-center align-items-center">
                <div class="loading-message">輸入中 </div>
                <img src="../assets/images/typing-loading.gif" class="loading-gif" alt="">
            </div>
            <div v-else class="d-flex flex-column flex-grow-1">
                <vue-markdown :source="chat.content" :plugins="markdownPlugins" />
                <div v-if="props.isShareEnabled" class="d-flex align-self-end action-icon-container">
                    <!-- <a class="action-icon" @click="emit('onShareClick', 'facebook', chat)">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_4023_3145)">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M12.5 0C5.9 0 0.5 5.4 0.5 12C0.5 18 4.9 22.9 10.6 23.8C10.6 22.9 10.6 15.4 10.6 15.4H7.5V11.9H10.6V8.9C10.5 7 11.7 5.4 13.5 4.8C14.9 4.5 16.4 4.5 17.9 4.8V7.8H16.4C14.8 7.8 14.4 8.7 14.5 10.1C14.5 10.7 14.5 11.3 14.5 11.9H17.8L17.3 15.4H14.5V23.8C20.1 22.9 24.5 18 24.5 12C24.5 5.4 19.1 0 12.5 0Z"
                                    fill="currentColor" />
                            </g>
                            <defs>
                                <clipPath id="clip0_4023_3145">
                                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </a> -->
                    <a class="action-icon" @click="emit('onShareClick', 'line', chat)">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_3698_12370)">
                                <g clip-path="url(#clip1_3698_12370)">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M12.5 0C5.9 0 0.5 5.4 0.5 12C0.5 18.6 5.9 24 12.5 24C19.1 24 24.5 18.6 24.5 12C24.5 5.4 19.1 0 12.5 0ZM18.8 14.9C17.1 16.8 13.4 19.2 12.5 19.5C11.6 19.9 11.8 19.3 11.8 19.1C11.8 19 11.9 18.4 11.9 18.4C11.9 18.2 12 17.9 11.9 17.7C11.8 17.5 11.5 17.4 11.2 17.3C7.4 16.8 4.5 14.1 4.5 10.9C4.5 7.3 8.1 4.4 12.5 4.4C16.9 4.4 20.5 7.3 20.5 10.9C20.5 12.3 19.9 13.6 18.8 14.9Z" />
                                    <path
                                        d="M17.8 12.9002H15.6C15.5 12.9002 15.5 12.8002 15.5 12.8002V9.3002C15.5 9.2002 15.6 9.2002 15.6 9.2002H17.8C17.9 9.2002 17.9 9.3002 17.9 9.3002V9.9002C17.9 10.0002 17.8 10.0002 17.8 10.0002H16.3V10.6002H17.8C17.9 10.6002 17.9 10.7002 17.9 10.7002V11.3002C17.9 11.4002 17.8 11.4002 17.8 11.4002H16.3V12.0002H17.8C17.9 12.0002 17.9 12.1002 17.9 12.1002V12.7002C18 12.9002 17.9 12.9002 17.8 12.9002Z" />
                                    <path
                                        d="M9.50001 12.9002C9.60001 12.9002 9.60001 12.8002 9.60001 12.8002V12.2002C9.60001 12.1002 9.50001 12.1002 9.50001 12.1002H8.00001V9.3002C8.00001 9.2002 7.90001 9.2002 7.90001 9.2002H7.30001C7.20001 9.2002 7.20001 9.3002 7.20001 9.3002V12.8002C7.20001 12.9002 7.30001 12.9002 7.30001 12.9002H9.50001Z" />
                                    <path
                                        d="M10.3 9.09961H10.9C11 9.09961 11.1 9.19961 11.1 9.29961V12.7996C11.1 12.8996 11 12.9996 10.9 12.9996H10.3C10.2 12.9996 10.1 12.8996 10.1 12.7996V9.29961C10.2 9.19961 10.2 9.09961 10.3 9.09961Z" />
                                    <path
                                        d="M14.7 9.09961H14.1C14 9.09961 14 9.19961 14 9.19961V11.2996L12.4 9.09961H11.8C11.7 9.09961 11.7 9.19961 11.7 9.19961V12.6996C11.7 12.7996 11.8 12.7996 11.8 12.7996H12.4C12.5 12.7996 12.5 12.6996 12.5 12.6996V10.5996L14.1 12.7996H14.7C14.8 12.7996 14.8 12.6996 14.8 12.6996V9.29961C14.9 9.19961 14.8 9.09961 14.7 9.09961Z" />
                                </g>
                            </g>
                            <defs>
                                <clipPath id="clip0_3698_12370">
                                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                                </clipPath>
                                <clipPath id="clip1_3698_12370">
                                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </a>
                    <a class="action-icon" @click="copyToClipboard">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" stroke="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.6 16.1H21.5V3H8.40002V7.9" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M16.6 7.90039H3.5V21.0004H16.6V7.90039Z" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>

        <div v-if="props.chat.suggestions.length > 0" class="d-flex flex-column chat-content chat-suggestions">
            <div>您可以這麼問...</div>
            <a v-for="(item, index) in chat.suggestions" :key="index" class="suggestion"
                :class="{ 'suggestion-disabled': !isPromptingEnabled }"
                @click="emit('onPromptSuggestionSelected', item)">
                {{ item }}
            </a>
        </div>
    </div>

    <div v-if="props.chat.type === 'user'" class="d-flex justify-content-end prompt">
        <div class="chat-content">{{ chat.content }}</div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, computed } from 'vue';
import { Notyf } from 'notyf';
import VueMarkdown from 'vue-markdown-render'
import markdownItLinkAttributes from 'markdown-it-link-attributes'
import MarkdownColor from 'markdown-it-color';
import Chat from '@/interfaces/Chat';
import MarkdownIt from 'markdown-it';

const props = defineProps<{
    chat: Chat;
    isShareEnabled: boolean;
    isPromptingEnabled: boolean;
}>();

const emit = defineEmits<{
    onPromptSuggestionSelected: [string];
    onShareClick: ['facebook' | 'line', Chat]
}>();

const markdownPlugins = computed(() => {
    return [
        (md: MarkdownIt) => md.use(markdownItLinkAttributes, {
            matcher(href: string){ return href.startsWith('https:') && href.includes('#nounderline') },
            attrs: {
                target: '_blank',
                style: 'color: #68444A; text-decoration: none;',
                rel: 'noopener noreferrer'
            }
        }),
        (md: MarkdownIt) => md.use(markdownItLinkAttributes, {
            pattern: /^(https?:|mailto:)/,
            attrs: {
                target: '_blank',
                style: 'color: #68444A',
                rel: 'noopener noreferrer'
            }
        }),
        (md: MarkdownIt) => md.use(MarkdownColor, {
            inline: true,
        })
    ];
});

const notyf = new Notyf({
    duration: 1500,
    ripple: false,
    position: { x: 'center', y: 'top' },
    types: [
        {
            type: 'success',
            background: 'grey',
        }
    ]
})

async function copyToClipboard() {
    await navigator.clipboard.writeText(props.chat.content);
    notyf.success({ message: '複製成功' });
}

</script>

<style scoped>
.chat-content {
    margin-bottom: 16px;
    gap: 16px;
}

.chat-content img {
    margin-bottom: auto;
    width: 56px;
    height: 56px;
}

.loading-message {
    display: inline;
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #9F7A74;
}

.loading-gif {
    width: 24px !important;
    height: 24px !important;
    margin: auto;
}

.action-icon-container {
    gap: 24px;
}

.action-icon {
    color: #68444A;
}

.action-icon:hover {
    color: #FF057D;
    cursor: pointer;
}

.message {
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 14px;
    font-weight: 400;
}

.chat-suggestions {
    align-items: start;
    padding-top: 16px;
    scroll-padding-bottom: 16px;
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 14px;
    color: #68444A;
}

.suggestion {
    display: flex;
    align-items: center;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
    border-color: #68444A;
    border-style: solid;
    border-width: 1px;
    border-radius: 4px;
    text-decoration: none;
    color: #68444A;
    cursor: pointer;
}

.suggestion:hover {
    background-color: #68444A;
    color: white;
}

.suggestion-disabled {
    pointer-events: none;
    cursor: not-allowed;
}

.prompt div {
    display: flex;
    align-items: center;
    margin-top: 16px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 14px;
    font-weight: 400;
    background-color: #68444A;
    color: white;
    border-radius: 24px;
}
</style>